import React, {useState} from 'react'
import {Box} from '@mui/material'
import TabBar from 'src/components-new/layout/TabBar'
import {useAppSelector} from 'src/hooks'
import PatientEnrollmentTab from './PatientEnrollmentTab'
import DigitalEnrollmentTab from './DigitalEnrollmentTab'

type TabKey = 'patientEnrollment' | 'digitalEnrollment'

/**
 * New-style equivalent of src/pages/enrollmentHub/EnrollmentHub.tsx. Both tabs are
 * PSP-configurable (`sidebarItems.patientEnrollment`/`digitalEnrollment`), same as the
 * legacy hub — unlike the legacy page's two independently-filtered `TABS`/`CONTENT`
 * arrays matched only by index, tabs and content are built from one filtered list, so
 * there's no risk of them drifting out of sync.
 */
export default function EnrollmentHubNew(): JSX.Element {
  const sidebarItems = useAppSelector(state => state.pspConfigReducer.data.sidebarItems)

  const TABS = [
    {
      key: 'patientEnrollment' as const,
      label: sidebarItems.patientEnrollment?.label ?? 'Iscrizione nuovo paziente',
      show: Boolean(sidebarItems.patientEnrollment?.show),
    },
    {
      key: 'digitalEnrollment' as const,
      label: sidebarItems.digitalEnrollment?.label ?? 'Adesioni digitali',
      show: Boolean(sidebarItems.digitalEnrollment?.show),
    },
  ].filter(tab => tab.show)

  const [activeTab, setActiveTab] = useState<TabKey | undefined>(TABS[0]?.key)

  const currentTab = TABS.find(tab => tab.key === activeTab) ?? TABS[0]

  return (
    <Box>
      {TABS.length > 1 && (
        <Box sx={{borderBottom: '1px solid', borderColor: 'divider', mb: 3}}>
          <TabBar
            tabs={TABS.map(({key, label}) => ({key, label}))}
            activeKey={currentTab?.key ?? ''}
            onChange={(key) => setActiveTab(key as TabKey)}
          />
        </Box>
      )}

      {currentTab?.key === 'patientEnrollment' && <PatientEnrollmentTab />}
      {currentTab?.key === 'digitalEnrollment' && <DigitalEnrollmentTab />}
    </Box>
  )
}
